import React from 'react';
import { classNames } from '../../components/helpers/functions';

export const Settings = ({ menu = [], children, onClick }) =>
	menu.map((item) => (
		<a
			key={item.name}
			onClick={() =>
				typeof item?.onClick === 'function'
					? item?.onClick()
					: typeof onClick === 'function'
					? onClick(item.id)
					: null
			}
			className={classNames(
				item.current
					? 'bg-teal-50 border-teal-500 text-teal-700 hover:bg-teal-50 hover:text-teal-700'
					: 'border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900',
				'group border-l-4 px-3 py-2 flex items-center text-sm font-medium cursor-pointer'
			)}
			aria-current={item.current ? 'page' : undefined}
		>
			{item?.icon && (
				<item.icon
					className={classNames(
						item.current
							? 'text-teal-500 group-hover:text-teal-500'
							: 'text-gray-400 group-hover:text-gray-500',
						'flex-shrink-0 -ml-1 mr-3 h-6 w-6'
					)}
					aria-hidden="true"
				/>
			)}
			<span className="truncate">{item.name}</span>
		</a>
	));
